/* Product fact corrections, confirmed by Rockkt on 9 August 2026.
   These swaps run on load so several large templates did not have to be rewritten
   during a live window. Fold each one into its template when next edited, then
   delete the corresponding entry here.

   Source of truth: no minimum terms on any tier, no Slack integration, no
   published credit allowance on Studio Free, real stamps, Managed fulfils
   internationally, Studio customers post wherever they like, annual billing
   is two months free on both products, and the gift catalogue is tens of
   thousands of products rather than millions. */
(function () {
  var SWAPS = [
    // Studio Free: free and by invitation, without publishing the allowance.
    ['Studio Free is five fully worked prospects a month, no card, by invitation.',
     'Studio Free is free, by invitation, and needs no card.'],
    ['Studio Free is five fully worked prospects a month, by invitation.',
     'Studio Free is free, by invitation, and needs no card.'],
    ['Five fully worked prospects a month, free by invitation, is enough to find out what your own scan rate looks like.',
     'Studio Free is free and by invitation, which is enough to find out what your own scan rate looks like.'],
    ['Five fully worked prospects a month, free by invitation, settles more arguments than a table does.',
     'Free by invitation, which settles more arguments than a table does.'],
    ['Studio Free is five fully worked prospects a month, by invitation, which is enough to test the branch on a real list.',
     'Studio Free is free and by invitation, which is enough to test the branch on a real list.'],
    ['Studio Free, 5 credits a month, by invitation, no card', 'Studio Free, by invitation, no card'],
    ['Studio Free, 5 credits a month, by invitation.', 'Studio Free, by invitation, no card.'],
    ['5 credits a month, by invitation', 'Free, by invitation'],
    // Credit mechanics stay off the marketing pages.
    ['One credit is one fully worked prospect and it comes off your allowance the moment the search runs, so the number in the app is always the truth rather than an estimate.',
     'The address is found and verified before anything is printed, so you know what you are sending and where before you commit to it.'],
    ['Credits come out of a monthly allowance. A hard cap, so no silent overage.',
     'Included in the monthly price. No per send surcharge.'],
    // Minimum terms: there are none.
    ['The Managed plans do carry minimum terms on the larger tiers, which are shown on the pricing page.',
     'Managed has no minimum term either. Enterprise is the only tier where a term might be negotiated.'],
    ['The larger Managed tiers do carry minimum terms, and those are shown on the pricing page.',
     'Managed has no minimum term either. Enterprise is the only tier where a term might be negotiated.'],
    ['No minimum term on any paid Studio tier, cancel anytime.', 'No minimum term on any tier, cancel anytime.'],
    ['No minimum term on paid Studio tiers.', 'No minimum term on any tier.'],
    ['No minimum term on any paid Studio tier and you can cancel at any time.',
     'No minimum term on any tier and you can cancel at any time.'],
    // Slack does not exist.
    ['Rockkt works as a Chrome extension over LinkedIn plus a web portal, and Slack is available on the Managed Growth tier and above. If a deep two way CRM integration is the deciding factor for you today, a larger platform will have more connectors.',
     'Rockkt works as a Chrome extension over LinkedIn plus a web portal. There is no CRM or chat integration today, so if a deep two way CRM integration is the deciding factor, a larger platform will have more connectors.'],
    // The QR code lives on the letter and is generated instantly.
    ['Personalised page with QR tracking, included', 'Personalised page, with the QR code printed on the letter'],
    ['Personalised, QR tracked, included', 'Personalised, with the QR code printed on the letter'],
    ['Included, personalised, with tracking', 'Included, with the QR code printed on the letter'],
    ['Included, personalised, tracked.', 'Included, with the QR code printed on the letter.'],
    // Envelopes carry a real stamp.
    ['keeps the envelope plain, and writes a first line built from something specific to that person rather than a merge field',
     'keeps the envelope plain, posts it with a real stamp, and writes a first line built from something specific to that person rather than a merge field'],
    // International.
    ['Rockkt is a UK company and posts through Royal Mail, so the fulfilment side is strongest in the UK.',
     'Rockkt is a UK company and fulfils internationally on Managed. On Studio you post it yourself, so you can send wherever you like.'],
    // Annual billing, confirmed 10 August 2026: two months free on both products.
    // The 15% figure is retired so there is one discount rule across the range.
    ['Managed annual saves 15% on your platform fee',
     'Managed annual gives you 2 months free (pay for 10, get 12)'],
    ['pay annually and save 15% on your platform fee',
     'pay annually and get 2 months free (pay for 10, get 12)'],
    // Homepage plan summary. Only Managed gift credit rolls over; Studio
    // allowances reset, and the bare line read as though it covered both.
    ['Credit rolls over', 'Managed gift credit rolls over'],
    // Gift Lab, corrected 13 August 2026. The catalogue is tens of thousands,
    // not millions, and the split hero on the homepage now says so in as many
    // words, so the two had to agree. Substring rather than the whole sentence
    // so the rest of the paragraph can be edited without breaking the swap.
    ['search millions of products', 'search tens of thousands of products']
  ];
  function walk(node) {
    if (node.nodeType === 3) {
      var t = node.nodeValue, changed = false;
      for (var i = 0; i < SWAPS.length; i++) {
        if (t.indexOf(SWAPS[i][0]) > -1) { t = t.split(SWAPS[i][0]).join(SWAPS[i][1]); changed = true; }
      }
      if (changed) node.nodeValue = t;
      return;
    }
    if (node.nodeType !== 1) return;
    var tag = node.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return;
    for (var c = node.firstChild; c; c = c.nextSibling) walk(c);
  }
  function run() { walk(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
